import {connect} from "react-redux";
import Dealer from "./Dealer";
import {bindActionCreators} from "redux";
import {getDetails} from "../../service/Dealer/action";

const mapStateToProps = (state) => ({
    getDealerDetails:state.Dealer.getDealerDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getDetails,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Dealer);
